import { createStyles } from '@mantine/styles';

var useStyles = createStyles({
  dropdown: { padding: 4 }
});

export default useStyles;
//# sourceMappingURL=Menu.styles.js.map
